module.exports = __webpack_public_path__ + "img/blog_menu_pic4.b0493900.png";